<script>
	import CtaWithCaption from '../CtaWithCaption/CtaWithCaption.svelte';

	/** @type {String} */
	export let ctaCaption;
	/** @type {String} */
	export let ctaLabel;
	/** @type {String} */
	export let ctaHref;
	/** @type {String} */
	export let description;
	/** @type {String} */
	export let imageDesktop;
	/** @type {String} */
	export let imageMobile;
	/** @type {String} */
	export let imagePlacement = 'left';
	/** @type {String} */
	export let title;
</script>

<div class="usp-row image-on-{imagePlacement}">
	<div class="media">
		<picture>
			<source srcset={imageMobile} media="(max-width: 767px)" />
			<source srcset={imageDesktop} media="(min-width: 768px)" />
			<img
				src={imageMobile ?? imageDesktop}
				alt={title}
				width="560"
				loading="lazy"
				decoding="async"
			/>
		</picture>

		<CtaWithCaption label={ctaLabel} caption={ctaCaption} href={ctaHref} on:click />
	</div>

	<div class="content">
		<h3 class="title">{@html title}</h3>

		<p class="description">{@html description}</p>

		<CtaWithCaption label={ctaLabel} caption={ctaCaption} href={ctaHref} on:click />
	</div>
</div>

<style>.usp-row{align-content:start;justify-content:center;place-content:start center;display:grid;grid-gap:1.75rem;gap:1.75rem;padding:.75rem .5rem}@media (min-width:767.02px){.usp-row{align-items:center;justify-items:center;place-items:center;margin-top:2rem;margin-bottom:2rem;grid-template-columns:1fr 1fr;gap:6rem}}.media{display:grid;align-items:center;justify-items:center;place-items:center;grid-gap:2rem;gap:2rem}@media (min-width:767.02px){.image-on-right .media{order:1}}@media (max-width:767px){.media :global(.cta-with-caption){display:none}}.content{display:grid;grid-gap:.75rem;gap:.75rem}@media (min-width:767.02px){.content{text-align:left;max-width:34rem}}.content :global(.cta-with-caption){margin-top:1rem}@media (min-width:767.02px){.content :global(.cta-with-caption){display:none}}.title{font:var(--f-heading-md-semibold)}.description{color:hsla(var(--hsl-black));font:var(--f-paragraph-md-medium)}.description :global(strong){color:hsla(var(--hsl-primary))}@media (max-width:767px){.content{text-align:center}}</style>
